import type { TersaImageModel } from '../../types';
import { providers } from '../../../providers';
import { alibaba } from '../../alibaba';
import { kie } from '../../kie';
import { wavespeed } from '../../wavespeed';

// 美元汇率
const RMB_TO_USD = 1 / 6.8;
// rmb to usd 转换
const usd = (rmb: number) => rmb * RMB_TO_USD;
const COST_FACTOR = 1.5;

export const qwenModels: Record<string, TersaImageModel> = {
    'qwen-image-3.0-pro': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: kie.image('qwen-image-3.0-pro'),
                modelBackup_create: [wavespeed.image('alibaba/qwen-image-3.0-pro/text-to-image')],
                model_edit: kie.image('qwen-image-3.0-pro'),
                modelBackup_edit: [wavespeed.image('alibaba/qwen-image-3.0-pro/edit')],
                getCost: ({ mode, providerOptions } = {}) => {
                    const resolution = (providerOptions?.image_resolution || '').toUpperCase();
                    const output = resolution === '2K' ? 0.075 : 0.04;
                    const input = mode === 'i2i' ? 0.003 : 0;
                    return (output + input) * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K'],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen-image-3.0': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: kie.image('qwen-image-3.0'),
                modelBackup_create: [wavespeed.image('alibaba/qwen-image-3.0/text-to-image')],
                model_edit: kie.image('qwen-image-3.0'),
                modelBackup_edit: [wavespeed.image('alibaba/qwen-image-3.0/edit')],
                getCost: ({ mode } = {}) => {
                    const output = 0.03;
                    const input = mode === 'i2i' ? 0.003 : 0;
                    return (output + input) * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K'],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen-image-2.1': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: kie.image('qwen-image-2.1'),
                modelBackup_create: [wavespeed.image('wavespeed-ai/qwen-image-2.1/text-to-image')],
                model_edit: kie.image('qwen-image-2.1'),
                modelBackup_edit: [wavespeed.image('wavespeed-ai/qwen-image-2.1/edit')],
                getCost: ({ mode } = {}) => {
                    // WaveSpeed 1K 目录价。分辨率和参考图张数不加价。
                    return (mode === 'i2i' ? 0.03 : 0.02) * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K'],
            },
            i2i: {
                sizes: ['match', '21x9', '9x21', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen-image-2.0-pro': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: alibaba.image('qwen-image-2.0-pro'),
                modelBackup_create: [wavespeed.image('qwen-image-2.0-pro/text-to-image')],
                model_edit: alibaba.image('qwen-image-2.0-pro'),
                modelBackup_edit: [wavespeed.image('qwen-image-2.0-pro/edit')],
                getCost: () => {
                    return usd(0.5 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen-image-2.0': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: alibaba.image('qwen-image-2.0'),
                modelBackup_create: [wavespeed.image('qwen-image-2.0/text-to-image')],
                model_edit: alibaba.image('qwen-image-2.0'),
                modelBackup_edit: [wavespeed.image('qwen-image-2.0/edit')],
                getCost: () => {
                    return usd(0.2 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen-image-max': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: alibaba.image('qwen-image-max'),
                modelBackup_create: [wavespeed.image('qwen-image-max/text-to-image')],
                model_edit: alibaba.image('qwen-image-max'),
                modelBackup_edit: [wavespeed.image('qwen-image-max/edit')],
                getCost: () => {
                    return usd(0.5 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen-image-plus': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: alibaba.image('qwen-image-plus'),
                model_edit: alibaba.image('qwen-image-plus'),
                modelBackup_edit: [wavespeed.image('qwen-image/edit-plus')],
                getCost: () => {
                    return usd(0.2 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 3, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen-image': {
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: undefined,
                model_create: alibaba.image('qwen-image'),
                modelBackup_create: [wavespeed.image('qwen-image/text-to-image')],
                model_edit: alibaba.image('qwen-image'),
                modelBackup_edit: [wavespeed.image('qwen-image/edit')],
                getCost: () => {
                    return usd(0.3 * COST_FACTOR);
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '9x21', '16x9', '9x16', '9x7', '7x9', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};